module.exports = __webpack_public_path__ + "img/down-arrow.19bbfc73.svg";